import { Component, Signal } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { WebsiteConfigFormExpansionPanelComponent } from '../website-config-form-expansion-panel/website-config-form-expansion-panel.component';

import { WebsiteStateService } from '../../../../../state-management/services/website-state.service';
import { BusinessConfiguration, Theming } from '../../../../../state-management/model/interfaces/state.model';
import { FontFamily } from '../../../../../state-management/model/enums/state.enums';

import { ColorPickerModule } from 'ngx-color-picker';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';




@Component({
  selector: 'app-website-config-form-styling',
  standalone: true,
  imports: [
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatOption,
    CommonModule,
    MatSelect,
    MatButtonModule,
    MatSlideToggleModule,
    ColorPickerModule,
    // MatCheckbox,
    MatButtonToggleModule,
    MatDividerModule,
    WebsiteConfigFormExpansionPanelComponent
  ],
  templateUrl: './website-config-form-styling.component.html',
  styleUrl: './website-config-form-styling.component.scss'
})
export class WebsiteConfigFormStylingComponent {
  public metaData: Signal<BusinessConfiguration> = this.websiteState.configuration;
  public themingData: Signal<Theming> = this.websiteState.theming;
  public advancedOptions: boolean = false;
  public tertiaryColor: string = this.metaData().theming.colors.tertiaryColor || "#fffff";
  public fontFamilies = Object.values(FontFamily);
  private debounceTimer: any;
  public colorOptions = [
    { name: 'Rot', primaryColor: '#f44336' },
    { name: 'Grün', primaryColor: '#4caf50' },
    { name: 'Blau', primaryColor: '#2196f3' },
    { name: 'Gelb', primaryColor: '#ffeb3b' },
    { name: "Cyan", primaryColor: "#00bcd4" },
    { name: "Magenta", primaryColor: "#e91e63" },
    { name: "Orange", primaryColor: "#ff9800" },
    { name: "Gelbgrün", primaryColor: "#7fff00" },
    { name: "Azurblau", primaryColor: "#007fff" },
    { name: "Rosa", primaryColor: "#ff007f" },
    { name: "Violett", primaryColor: "#8a2be2" },
    { name: 'Braun', primaryColor: '#795548' },
  ];
  public colorStrings = this.colorOptions.map(option => option.primaryColor);

  constructor(private websiteState: WebsiteStateService) { }

  public getContrastYIQ(hex: string): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? '#000000' : '#FFFFFF'; // Helle Farben bekommen schwarzen Text, dunkle weißen
  }

  public updateLightModeTheming(lightMode: boolean): void {
    this.websiteState.updateTheming({ lightMode });
  }

  public updateTypographyTheming(brandTypography?: FontFamily, plainTypography?: FontFamily): void {
    const updatedTypography = {
      ...this.themingData().typography, // Vorhandene Werte übernehmen
      ...(brandTypography ? { brandTypography } : {}),
      ...(plainTypography ? { plainTypography } : {})
    };
    this.websiteState.updateTheming({ typography: updatedTypography });
  }

  public updateColorTheming(primaryColor?: any, tertiaryColor?: any): void {
    const updatedColors = {
      ...this.themingData().colors, // Vorhandene Werte übernehmen
      ...(primaryColor ? { primaryColor } : {}), // Überschreiben, wenn primaryColor gesetzt ist
      ...(tertiaryColor ? { tertiaryColor } : {}) // Überschreiben, wenn tertiaryColor gesetzt ist
    };
    this.websiteState.updateTheming({ colors: updatedColors });
  }

  public onPrimaryColorChange(newPrimaryColor: string): void {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.updateColorTheming(newPrimaryColor);
    }, 300); // 300ms Verzögerung  
  }

  public onTertiaryColorChange(newTertiaryColor: string): void {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.updateColorTheming(undefined, newTertiaryColor);
    }, 300); // 300ms Verzögerung  
  }
}
